/*! @pentacode/ui v0.1.0 */
// src/charts/format.ts
var e = "de-DE", t = new Intl.NumberFormat(e, {
	style: "currency",
	currency: "EUR",
	maximumFractionDigits: 0,
	signDisplay: "negative"
}), n = new Intl.NumberFormat(e, {
	style: "currency",
	currency: "EUR",
	signDisplay: "negative"
}), r = new Intl.NumberFormat(e, {
	maximumFractionDigits: 1,
	signDisplay: "negative"
}), i = new Intl.NumberFormat(e, {
	style: "percent",
	maximumFractionDigits: 0,
	signDisplay: "negative"
}), a = new Intl.DateTimeFormat(e, {
	day: "2-digit",
	month: "2-digit"
}), o = new Intl.DateTimeFormat(e, { month: "short" }), s = new Intl.DateTimeFormat(e, {
	hour: "2-digit",
	minute: "2-digit"
});
function c(e) {
	return e instanceof Date ? e : new Date(e);
}
function l(e, { precise: r = !1 } = {}) {
	return (r ? n : t).format(Number(e));
}
function u(e) {
	return r.format(Number(e));
}
function d(e) {
	return `${r.format(Number(e))} h`;
}
function f(e) {
	return i.format(Number(e));
}
function p(e) {
	return a.format(c(e));
}
function m(e) {
	return o.format(c(e));
}
function h(e) {
	return s.format(c(e));
}
export { l as formatCurrency, p as formatDay, u as formatDecimal, h as formatHour, d as formatHours, m as formatMonth, f as formatPercent };

//# sourceMappingURL=format.js.map